import Enum from '../tools/enum'

class AppEnum{

    constructor(){
       this.ReadMHType=new ReadMHType()
    }
    
}

class ReadMHType{
    constructor(){
        this.Create=1;  //创建的纪念馆
        this.Follow=2; //关注的纪念馆
    }
}

export default AppEnum;